import React from 'react';
import { IconProps } from '../../icons/types';

const AgentsStatusIcon: React.FC<IconProps> = props => {
  const { width = 24, height = 24, strokeColor = 'var(--bg-primary)' } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.96155 8.76317H21.0486V20.0996C21.0486 20.6218 20.6213 21.0491 20.0991 21.0491H3.911C3.3888 21.0491 2.96155 20.6218 2.96155 20.0996V8.76317Z"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M3.911 4.85144H20.0991C20.6213 4.85144 21.0486 5.27869 21.0486 5.80089V8.75368H2.96155V5.80089C2.96155 5.27869 3.3888 4.85144 3.911 4.85144Z"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path d="M7.63275 3V7.13961" stroke={strokeColor} strokeWidth="1.2" strokeMiterlimit="10" />
      <path d="M16.3679 3V7.13961" stroke={strokeColor} strokeWidth="1.2" strokeMiterlimit="10" />
      <path
        d="M8.58241 12.7129H6.65503"
        stroke={strokeColor}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8.5826 17.0994H6.65521"
        stroke={strokeColor}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12.9784 12.7129H11.051"
        stroke={strokeColor}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12.9784 17.0994H11.051"
        stroke={strokeColor}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.3465 12.7129H15.4191"
        stroke={strokeColor}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.3465 17.0994H15.4191"
        stroke={strokeColor}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AgentsStatusIcon;
